import BaseMove from "./base-move";
import {ActionTypeEnum} from "../../base/training-literals";

class MoveBranch extends BaseMove {
    modelId;
    branchIdList;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.MOVE_BRANCH;
        this.modelId = props.modelId || "";
        this.branchIdList = props.branchIdList || "";
    }

    get(props = {}) {
        return {
            type: this.actionType,
            modelId: props.modelId || this.modelId,
            branchIdList: props.branches || this.branchIdList,
            moveSteps: props.moveSteps || []
        }
    }

    startModelSelectionCallback(itemArr) {
        const actionId = itemArr[0];
        if (!this.shouldExecute(actionId)) return;

        this.startSelectionForMove();
    }

    startSelectionForMove() {
        this.startModelSelection = true;
        const applyToType = CatchTargetTypeEnum.TREE;
        VRMessageController.addMessage({
            text: "Select one branch from model tree and apply move.",
            priority: VrMessagePriorityEnum.LOWPRIORITYINFO
        });
        MeshHierarchyViewFeatureManager.resetTreeViewSelection();
        if (is_current_user_presenter()) {
            wv.sendTextMessage(text_handleDeselectAllButtonOperation);
        }

        super.startSelectionForMove(applyToType);
        this.handle2dItemsForStartSelection();
    }

    selectEntityForEditingMove(entityName) {
        this.cancelSelection = false;
        this.startModelSelection = true;
        this.handle2dItemsForSelectEntity(entityName);

        CatchVolumeFeatureController.onChangeMoveFeature(true);
        CatchVolumeFeatureController.onSelectApplyToType(CatchTargetTypeEnum.TREE);
        catchBody(undefined, undefined, undefined, undefined, {branchIdList: entityName});
        this.startModelSelection = false;
    }

    handle2dItemsForStartSelection() {
        super.set2dElementsVisibility(false);
        const modelTreeViewList = document.getElementsByClassName('modelTreeView');
        const selectorButtons = document.getElementsByClassName('modelTreeSelectorClass');
        const itemsToShow = [...modelTreeViewList, ...selectorButtons];
        for (let item of itemsToShow) {
            item.style.visibility = 'visible';
        }

        JSTreeManager.hideAllOtherTreeViews();
        ModelTreeControllerFor2D.showModelTree = true;
        JSTreeManager.showModelTreeView('modelTreeViewSideNav', ModelTreeControllerFor2D.showModelTree);
        JSTreeManager.showFeatureListTreeView('AvailableFileListViewSideNav', false);
    }

    handle2dItemsForSelectEntity(branchIds) {
        super.set2dElementsVisibility(false);
        const modelTreeButton = document.getElementById('modelTreeSelectorButtons');
        modelTreeButton.style.visibility = 'visible';
        JSTreeManager.hideAllOtherTreeViews();
        ModelTreeControllerFor2D.deselectAllNodes();
        this.selectBranchesInModelTree(branchIds);
        ModelTreeControllerFor2D.showModelTree = false;
        JSTreeManager.showModelTreeView('modelTreeViewSideNav', ModelTreeControllerFor2D.showModelTree);
        JSTreeManager.showFeatureListTreeView('AvailableFileListViewSideNav', false);
    }

    selectBranchesInModelTree(branchIds) {
        for (let branchId of branchIds) {
            ModelTreeControllerFor2D.onChangeCheckStatus(branchId, true);
        }
    }

    recordDataOnCatchBody(caughtVolume) {
        MoveObjectActionController.modelId = caughtVolume.model.id;
        MoveObjectActionController.modelName = caughtVolume.model.name;
        MoveObjectActionController.branchIdList = caughtVolume.branchIdList;
        MoveObjectActionController.capturePivot();
    }

    getData() {
        ModelTreeControllerFor2D.deselectAllNodes();
        let firstVolumeLocalMatrix = new THREE.Matrix4();
        if (MoveObjectActionController.modelId && MoveObjectActionController.branchIdList?.length > 0) {
            const leaveVolume = MeshHierarchyViewFeatureData.getDataFromBranchID(MoveObjectActionController.branchIdList[0]).getLeaveVolumes()[0];
            if (leaveVolume) {
                firstVolumeLocalMatrix = getVolumeLocalMatrix(MoveObjectActionController.modelId, leaveVolume.branchID).clone();
            }
        }

        let position = new THREE.Vector3();
        let quaternion = new THREE.Quaternion();
        let scale = new THREE.Vector3();
        firstVolumeLocalMatrix.decompose(position, quaternion, scale);

        MoveObjectActionController.capturePivot();
        const pivot = MoveObjectActionController.pivot;

        return {
            position: position.toArray(),
            quaternion: quaternion.toArray(),
            scale: scale.toArray(),
            pivot: pivot
        };
    }

    catchObjectToMove() {
        catchBody(undefined, undefined, undefined, undefined,
            {branchIdList: MoveObjectActionController.branchIdList ? MoveObjectActionController.branchIdList : []});

        if (!wv.effectController.bodyCaught) {
            VRMessageController.addMessage({
                text: "Click on any of the highlighted objects before applying transform.",
                priority: VrMessagePriorityEnum.LOWPRIORITYINFO,
            });
        }
    }

    setObjectToPosition(entityNames, moveData) {
        const volumeFinalMatrix = this.getMoveMatrix(moveData);

        let branchIdArray = [];
        for (let branchId of entityNames) {
            const node = MeshHierarchyViewFeatureData.getDataFromBranchID(branchId);
            branchIdArray = node ? node.getLeaves() : [];
            if (branchIdArray.length > 0) {
                break;
            }
        }

        if (branchIdArray.length > 0) {
            let volumeCurrentMatrix = new THREE.Matrix4();
            if (moved_volume_matrices[branchIdArray[0]]) {
                volumeCurrentMatrix.copy(moved_volume_matrices[branchIdArray[0]]);
            }

            let applyMatrix = volumeFinalMatrix.clone();
            volumeCurrentMatrix.invert();
            applyMatrix.multiply(volumeCurrentMatrix);
            applyMatrix = getTransformationMatrixForVolumeExplosion(modelManager.getVolume(branchIdArray[0]), applyMatrix);
            for (let branchId of entityNames) {
                CADModelTransformationAnimationManager.transformVolumeWithoutAnimation(branchId, applyMatrix);
            }
        }
    }
}

export default MoveBranch;
